var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-outer-wrapper" },
    [
      _c(
        "el-row",
        { staticClass: "main-content" },
        [
          _c("el-col", { staticClass: "left-content", attrs: { span: 24 } }, [
            _c(
              "div",
              { staticClass: "content-wrapper" },
              [
                _c("h2", { staticClass: "title" }, [
                  _vm._v("Feature Your Projects on the Real Estate")
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "subtitle" }, [
                  _vm._v("Platform Designed for Off-the-plan")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "description" }, [
                  _vm._v(
                    "\n            Discover a community tailored exclusively for real estate agents specialising in off-the-plan and newly built properties. UNIFI connects you with a targeted audience and provides valuable resources to assist you in selling off-the-plan in the competitive property market. Ready to elevate your business? Click below to request our Agent Kit and learn how to get started with UNIFI today!\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-card",
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c("el-divider", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "600",
                                    "font-size": "14px"
                                  }
                                },
                                [_vm._v("Request Agent Kit")]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        ref: "requestAgentForm",
                        staticStyle: {
                          "font-family": "DINosaur-a, sans-serif"
                        },
                        attrs: {
                          model: _vm.requestAgentForm,
                          rules: _vm.rules,
                          "label-position": "top",
                          "label-width": "100px"
                        },
                        nativeOn: {
                          submit: function($event) {
                            $event.preventDefault()
                          }
                        }
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "First Name",
                                              prop: "firstName"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                maxlength: "50",
                                                placeholder: "Your first name"
                                              },
                                              model: {
                                                value:
                                                  _vm.requestAgentForm
                                                    .firstName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.requestAgentForm,
                                                    "firstName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "requestAgentForm.firstName"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Last Name",
                                              prop: "lastName"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                maxlength: "100",
                                                placeholder: "Your last name"
                                              },
                                              model: {
                                                value:
                                                  _vm.requestAgentForm.lastName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.requestAgentForm,
                                                    "lastName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "requestAgentForm.lastName"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Company",
                                              prop: "companyName"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                maxlength: "100",
                                                placeholder:
                                                  "Agency/Developer name"
                                              },
                                              model: {
                                                value:
                                                  _vm.requestAgentForm
                                                    .companyName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.requestAgentForm,
                                                    "companyName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "requestAgentForm.companyName"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Location",
                                              prop: "state"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  filterable: "",
                                                  placeholder: "Select a state"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.validateField(
                                                      "state"
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.requestAgentForm.state,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.requestAgentForm,
                                                      "state",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "requestAgentForm.state"
                                                }
                                              },
                                              _vm._l(_vm.STATES(), function(
                                                item
                                              ) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Email",
                                              prop: "email"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                maxlength: "100",
                                                placeholder: "Your email"
                                              },
                                              model: {
                                                value:
                                                  _vm.requestAgentForm.email,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.requestAgentForm,
                                                    "email",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "requestAgentForm.email"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Phone Number",
                                              prop: "phoneNumber"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                maxlength: "20",
                                                placeholder: "Your phone number"
                                              },
                                              model: {
                                                value:
                                                  _vm.requestAgentForm
                                                    .phoneNumber,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.requestAgentForm,
                                                    "phoneNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "requestAgentForm.phoneNumber"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Message",
                                              prop: "message"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                maxlength: "1000",
                                                "show-word-limit": "",
                                                placeholder: "Message"
                                              },
                                              model: {
                                                value:
                                                  _vm.requestAgentForm.message,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.requestAgentForm,
                                                    "message",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "requestAgentForm.message"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "text-align": "center"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "join-btn",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onSubmit(
                                                      "requestAgentForm"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          REQUEST AGENT KIT\n                          "
                                                ),
                                                _vm.loading
                                                  ? _c("i", {
                                                      staticClass:
                                                        "el-icon-loading"
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c("el-divider", [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                display: "flex",
                                "text-align": "center"
                              }
                            },
                            [_vm._v("Already have an agent account?")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "sign-in-btn",
                            attrs: { type: "primary", size: "large" },
                            on: { click: _vm.redirectToAgentLogin }
                          },
                          [_vm._v("\n                SIGN IN\n              ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "right-content", attrs: { span: 24 } }, [
            _c("div", { staticClass: "image-wrapper" }, [
              _c("img", {
                staticClass: "background-image",
                attrs: {
                  src: require("../../../assets/agent-reg-background.png"),
                  alt: ""
                }
              })
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55c5f61d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55c5f61d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/agentRegistration/agentRegistrationSection1.vue
// module id = null
// module chunks = 